module.exports = __webpack_public_path__ + "img/R. Zvi Klor.d886cb94.png";